import React, { useState } from 'react';
import api from '../api/client';
import Seo from '../components/Seo';
import { OrderView } from './Order';
import { useUI } from '../context/UIContext';

export default function TrackOrder() {
  const { toast } = useUI();
  const [number, setNumber] = useState('');
  const [phone, setPhone] = useState('');
  const [order, setOrder] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.get(`/orders/track/${number.replace('#', '').trim()}`, { params: { phone } });
      setOrder(r.order);
    } catch (err) {
      toast(err.message, 'error');
    }
  };
  return (
    <>
      <Seo title="Track your order" description="Track the status of your order." />
      <div className="container-fluid section-my">
        <h1 className="text-3xl md:text-4xl text-center mb-8">Track your order</h1>
        <form onSubmit={submit} className="max-w-md mx-auto eg-card mb-10">
          <input className="form-control w-full mb-3" placeholder="Order number (e.g. EG01001)" value={number} onChange={(e) => setNumber(e.target.value)} required />
          <input className="form-control w-full mb-4" placeholder="Phone number used on the order" value={phone} onChange={(e) => setPhone(e.target.value)} required />
          <button type="submit" className="sf__btn sf__btn-primary w-full">Track</button>
        </form>
        {order && <OrderView order={order} />}
      </div>
    </>
  );
}
